import { createContext } from "react";
import useWebSocketKubik from "../hooks/useWebSocketKubik";


export const WebSocketContext = createContext<{
    isConnected: boolean;
    subscribeWebSocket: (eventType: string, callback: (data: any) => void) => void;
    unsubscribeWebSocket: (eventType: string, callback: (data: any) => void) => void;
} | null>(null);

export const WebSocketProvider: React.FC<React.PropsWithChildren> = ({
    children,
}) => {
    const { isConnected, subscribeWebSocket, unsubscribeWebSocket } = useWebSocketKubik();

    return (
        <WebSocketContext.Provider
            value={{
                isConnected,
                subscribeWebSocket,
                unsubscribeWebSocket,
            }}
        >
            {children}
        </WebSocketContext.Provider>
    );
};